import Vue       from 'vue';
import VueRouter from 'vue-router';
import Cookie    from 'js-cookie';
import JWTDecode from 'jwt-decode';
import Store     from './store.js';

Vue.use( VueRouter );

//////////////////////
// Route Components //
//////////////////////

import Home                     from '@/components/home'
import About                    from '@/components/about'
import Contact                  from '@/components/contact'
import AccountSignin            from '@/components/account/signin'
import AccountSignup            from '@/components/account/signup'
import PatientWelcome           from '@/components/patient/patient-welcome'
import PatientForgotPassword    from '@/components/patient/patient-forgot-password'
import ProviderWelcome          from '@/components/provider/provider-welcome'
import ProviderForgotPassword   from '@/components/provider/provider-forgot-password'
import ProviderChangePassword   from '@/components/provider/provider-change-password'

var router = new VueRouter(
        {
            routes: [
                {
                    path:       '/',
                    name:       'HOme',
                    component:  Home,
                    meta:       { requiresAuth: false, providerAuth: false, patientAuth: false }
                },
                {
                    path:       '/about',
                    name:       'About',
                    component:  About,
                    meta:       { requiresAuth: false, providerAuth: false, patientAuth: false }
                },
                {
                    path:       '/contact',
                    name:       'Contact',
                    component:  Contact,
                    meta:       { requiresAuth: false, providerAuth: false, patientAuth: false }
                },
                {
                    path:       '/account/signin',
                    name:       'Signin',
                    component:  AccountSignin,
                    meta:       { requiresAuth: false, providerAuth: false, patientAuth: false }
                },
                {
                    path:       '/account/signup',
                    name:       'Signup',
                    component:  AccountSignup,
                    meta:       { requiresAuth: false, providerAuth: false, patientAuth: false }
                },
                {
                    path:       '/patient/forgot-password',
                    name:       'PatientForgotPassword',
                    component:  PatientForgotPassword,
                    meta:       { requiresAuth: false, providerAuth: false, patientAuth: false }
                },
                {
                    path:       '/patient/welcome',
                    name:       'PatientWelcome',
                    component:  PatientWelcome,
                    meta:       { requiresAuth: true, providerAuth: false, patientAuth: true }
                },
                {
                    path:       '/provider/forgot-password',
                    name:       'ProviderForgotPassword',
                    component:  ProviderForgotPassword,
                    meta:       { requiresAuth: false, providerAuth: false, patientAuth: false }
                },
                {
                    path:       '/provider/change-password',
                    name:       'ProviderChangePassword',
                    component:  ProviderChangePassword,
                    meta:       { requiresAuth: true, providerAuth: true, patientAuth: false }
                },
                {
                    path:       '/provider/welcome',
                    name:       'ProviderWelcome',
                    component:  ProviderWelcome,
                    meta:       { requiresAuth: true, providerAuth: true, patientAuth: false }
                }
            ]
        }
    );

router.beforeEach(
        ( to, from, next ) =>
        {
            if( to.meta.requiresAuth )
            {
                var accessToken = {};
                var userInfo  = Cookie.getJSON( 'meta-user' );
                if( userInfo != null && userInfo.tokens != null )
                {
                    if( to.meta.providerAuth )
                    {
                        if( userInfo.type.toLowerCase() === "provider" )
                            accessToken = userInfo.tokens.accessToken;
                    }
                    else if( to.meta.patientAuth )
                    {
                        if( userInfo.type.toLowerCase() === "patient" )
                            accessToken = userInfo.tokens.accessToken;
                    }
                }

                var now    = new Date();
                var access = JWTDecode( accessToken );
                if( access != null )
                {
                    if( now.getMilliseconds() < access.exp )
                    {
                        next();
                    }
                    else
                    {
                        next( '/account/signin' );
                    }
                }
            }
            else
            {
                next();
            }
        }
    );

export default router;



// WEBPACK FOOTER //
// ./src/router.js